import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Avatar,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Collapse,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import DraggableList from '../DraggableList';
import competencyService from "../../../../services/competency.service";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevronDown.svg";
import { ReactComponent as ChevronRight } from "../../../../assets/icons/chevronRight.svg";
import { ReactComponent as IconImport } from "../../../../assets/icons/import.svg";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import { ReactComponent as Eye } from "../../../../assets/icons/eye.svg";
import exports from "../../../../assets/images/export.png";
// import DotMenuGoalGroup from "./DotMenuGoalGroup";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import * as Util from "../../../../services/global.service";
import adminService from "../../../../services/admin.service";
import { useSelector, useDispatch } from "react-redux";
import { listGoalGroup } from "../../../../actions/admin";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ReactComponent as Manage } from "../../../../assets/images/manage.svg";
import { ReactComponent as Evaluate } from "../../../../assets/images/evaluate.svg";
import { ReactComponent as Result } from "../../../../assets/images/result.svg";
import evaluateService from "../../../../services/evaluate.service";

const useStyles = makeStyles({
    dateTimePicker: {
        display: "flex !important",
        flexDirection: "column !important",
        justifyContent: "space-between !important",
        position: "relative",
        marginBottom: "14px !important",

    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    input: {
        '& div > input': {
            height: '7px',
            position: "relative"
        }
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ManageForm = (props) => {
    let { data, isDeleteForm, type, selected, handleClick, workflowStatus, cycleType, formType } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [dataStatus, setDataStatus] = React.useState([]);
    let onChangeOpen = () => {
        setOpen(!open)
    }
    const isSelected = (id) => selected.indexOf(id) !== -1;
    const isItemSelected = isSelected(data.id);
    let getColor = (code) => {
        if (Util.formatData(workflowStatus, []).length > 0) {
            let data = workflowStatus.filter((rs) => rs?.code === code)
            if (data.length > 0 && Util.formatData(data[0]?.color, false) !== false) {
                return data[0]?.color
            }
        }
        return false;
    }
    let getName = (code) => {
        if (Util.formatData(workflowStatus, []).length > 0) {
            let data = workflowStatus.filter((rs) => rs?.code === code)
            if (data.length > 0 && Util.formatData(data[0]?.label, false) !== false) {
                return data[0]?.label
            } else {
                return "-"
            }
        }
        return "-"
    }
    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));
    const handleGoToDetail = (serial, isNew, type) => {
        if (isNew === true) {
            evaluateService.logIsRead(serial).then(
                (response) => {
                    if (type === "manage") {
                        navigate(`/admin/360evaluation/manage/${serial}`, { replace: false });
                    } else if (type === "evaluate") {
                        navigate(`/admin/360evaluation/${serial}/3`, { replace: false });
                    } else {
                        navigate(`/admin/360evaluation/${serial}/result/admin`, { replace: false });
                    }
                },
            )
        } else {
            if (type === "manage") {
                navigate(`/admin/360evaluation/manage/${serial}`, { replace: false });
            } else if (type === "evaluate") {
                navigate(`/admin/360evaluation/${serial}/3`, { replace: false });
            } else {
                navigate(`/admin/360evaluation/${serial}/result/admin`, { replace: false });
            }
        }
    };
    return (
        <Box px="40px">
            <Box sx={{ width: "100%", position: "relative" }}>
                <Box sx={{ height: "97px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }} pr="20px">
                    <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(42.95% - 66.67px)" }} pr="15px">
                        <Box px="20px" sx={{ display: "flex", alignItems: "center" }}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={data.serial}
                            selected={isItemSelected}>
                            {isDeleteForm === true || type === "deleted" ?
                                <Checkbox
                                    onClick={(event) => handleClick(event, data.id)}
                                    sx={{ margin: "0 20px 0 0", padding: "0" }}
                                    // onChange={e => changeType(data?.serial)} 
                                    checked={isItemSelected}
                                />
                                : null
                            }
                            {cycleType === "360" ?
                                <Box sx={{ borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                </Box>
                                :
                                <Box sx={{ background: "#F5F5F5", borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={onChangeOpen}>
                                    {open ? <ChevronDown /> : <ChevronRight />}
                                </Box>
                            }
                        </Box>
                        <Box sx={{ width: isDeleteForm === true || type === "deleted" ? "calc(100% - 108px)" : "calc(100% - 65px)" }}>
                            <BootstrapTooltip title={Util.formatData(data?.form?.name, "-")} placement="top">
                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ cursor: "pointer", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {Util.formatData(data?.form?.name, "-")}
                                </Typography>
                            </BootstrapTooltip>
                            <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                {t('label.period')}: {Util.formatData(data?.form?.start_at, false) === false && Util.formatData(data?.form?.end_at, false) === false ? "-" :
                                    Util.formatData(data?.form?.start_at, false) === false ? Util.dateDayFormatAdmin(data?.form?.end_at) :
                                        Util.formatData(data?.form?.end_at, false) === false ? Util.dateDayFormatAdmin(data?.form?.start_at) :
                                            `${Util.dateDayFormatAdmin(data?.form?.start_at)} - ${Util.dateDayFormatAdmin(data?.form?.end_at)}`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(33.25% - 66.67px)" }} pr="15px">
                        <Avatar
                            src={Util.formatData(data?.employee?.photo, "")}
                            sx={{
                                cursor: "pointer",
                                width: 40,
                                height: 40,
                            }}
                        />
                        <Box sx={{ width: "calc(100% - 40px)" }} pl="15px">
                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                {Util.formatData(data?.employee?.name, "-")} {Util.formatData(data?.employee?.code, false) !== false ? `(${data?.employee?.code})` : ""}
                            </Typography>
                            <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                {Util.formatData(data?.employee?.position, "-")} {Util.formatData(data?.employee?.position, false) === false ? "" : `(${data?.employee?.organization})`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(23.80% - 66.67px)" }} pr="15px">
                        {/* {getColor(data?.form_status) === false ?
                            null
                            : <Box mr="8px" sx={{ borderRadius: "50%", height: "10px", width: "10px", background: getColor(data?.form_status) }}></Box>
                        }
                        <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                            {getName(data?.form_status)}
                        </Typography> */}
                        <Box py="8px" px="20px" sx={{ "max-width": "150px", width: "100%", border: data?.form_status?.code === "draft" && data?.type !== "goal" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: data?.form_status?.code === "draft" && data?.type !== "goal" ? "none" : data?.form_status?.color + "1A" }} >

                            {(data?.status.toLowerCase() === 'delete' && data?.updated_by_name) ? (
                                <Typography pt="2px" fontSize={14} color="#A3A3A3" fontWeight="400"
                                >Deleted by {data?.updated_by_name}
                                </Typography>
                            ) : (
                                <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={data?.form_status?.color} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {data?.form_status?.label}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ width: "100px", display: "flex" }}>
                        <Typography fontSize={16} lineHeight="23.92px" color={data?.status === "acitve" ? "#5DA196" : "#AAAAAA"} fontWeight="400" sx={{ textAlign: "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                            {data?.status.toUpperCase()}
                            {(data?.status.toLowerCase() === 'delete') && <Typography pt="2px" fontSize={12} color="#A3A3A3" fontWeight="400">{data?.updated_at}</Typography>}
                        </Typography>
                        {/* <Eye onClick={() => { openNewTab("/kpi/mygoal/" + data?.id) }} style={{ cursor: "pointer" }} /> */}
                    </Box>
                    {cycleType === "360" ?
                        <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "justify-content": "flex-end" }}>
                            <Box sx={{ display: "flex", "flex-direction": "row", "justify-content": "center", width: "100px", "z-index": "1" }}>
                                {data?.action?.manage ?
                                    <Box pr="15px">
                                        <BootstrapTooltip title={t("360Evaluation.label.manage")} placement="top">
                                            <Manage style={{ cursor: "pointer" }} onClick={() => handleGoToDetail(data?.id, data?.is_new, "manage")} />
                                        </BootstrapTooltip>
                                    </Box>
                                    :
                                    <Box pr="15px">
                                        <Manage style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                    </Box>
                                }
                                {data?.action?.result ?
                                    <Box>
                                        <BootstrapTooltip title={t("360Evaluation.label.result")} placement="top">
                                            <Result style={{ cursor: "pointer" }} onClick={() => handleGoToDetail(data?.id, data?.is_new, "result")} />
                                        </BootstrapTooltip>
                                    </Box>
                                    :
                                    <Box>
                                        <Result style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                    </Box>
                                }
                            </Box>
                        </Box>
                        :
                        null
                    }
                </Box>
                <Collapse in={open}>
                    <Box>
                        <Box sx={{ background: "#FFF", width: "100%", display: "flex", "align-items": "center" }} pr="20px">
                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(42.95% - 66.67px)" }} pr="15px">
                                <Box px="20px">
                                    <Box sx={{ borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}></Box>
                                </Box>
                                <Box sx={{ width: "calc(100% - 65px)" }}>
                                    <Typography fontSize={18} lineHeight="26.91px" color="#A0A0A0" fontWeight="600" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                        {t('label.titleForm.cycle')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(33.25% - 66.67px)" }} pr="15px">
                                <Typography fontSize={18} lineHeight="26.91px" color="#A0A0A0" fontWeight="600" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {t('label.titleForm.evaluator')}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(23.80% - 66.67px)" }} pr="15px">
                                {/* <Typography fontSize={18} lineHeight="26.91px" color="#A0A0A0" fontWeight="600" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {t('evaluation.step')}
                                </Typography> */}
                            </Box>
                            <Box sx={{ width: "100px", display: "flex" }}>
                                {/* <Typography fontSize={18} lineHeight="26.91px" color="#A0A0A0" fontWeight="600" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}> */}
                                {/* {t('label.formStatus')} */}
                                {/* Status */}
                                {/* </Typography> */}
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "justify-content": "flex-end" }}>

                            </Box>
                        </Box>
                        <Box
                            pt="2px" pb="25px" pr="20px" sx={{ background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(42.95% - 66.67px)" }} pl="65px" pr="15px">
                                <Box sx={{ width: "calc(100% - 65px)" }}>
                                    <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                        {Util.formatData(data?.cycle?.name, "-")}
                                    </Typography>
                                    <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                        {Util.formatData(data?.cycle?.start_at, false) === false && Util.formatData(data?.cycle?.end_at, false) === false ? "-" :
                                            Util.formatData(data?.cycle?.start_at, false) === false ? Util.dateDayFormatAdmin(data?.cycle?.end_at) :
                                                Util.formatData(data?.cycle?.end_at, false) === false ? Util.dateDayFormatAdmin(data?.cycle?.start_at) :
                                                    `${Util.dateDayFormatAdmin(data?.cycle?.start_at)} - ${Util.dateDayFormatAdmin(data?.cycle?.end_at)}`}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(33.25% - 66.67px)" }} pr="15px">
                                <Avatar
                                    src={Util.formatData(data?.evaluator?.photo, "")}
                                    sx={{
                                        cursor: "pointer",
                                        width: 40,
                                        height: 40,
                                    }}
                                />
                                <Box sx={{ width: "calc(100% - 40px)" }} pl="15px">
                                    <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                        {Util.formatData(data?.evaluator?.name, "-")} ({Util.formatData(data?.evaluator?.code, "-")})
                                    </Typography>
                                    <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                        {Util.formatData(data?.evaluator?.position, "-")} {Util.formatData(data?.evaluator?.organization, false) === false ? "" : `(${data?.evaluator?.organization})`}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "calc(23.80% - 66.67px)" }} pr="15px">
                                {/* <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {Util.formatData(data?.workflow_status?.label, "-")}
                                </Typography> */}
                            </Box>
                            <Box sx={{ width: "100px", display: "flex", }}>
                                {/* <Typography fontSize={16} lineHeight="23.92px" color={data?.status === "acitve" ? "#5DA196" : "#AAAAAA"} fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                    {data?.status === "acitve" ? "ACTIVE" : "INACTIVE"}
                                </Typography> */}
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "justify-content": "flex-end" }}>

                            </Box>
                        </Box>
                    </Box>

                </Collapse>
            </Box>
            <Divider width="100%" />
        </Box >

    );
};
export default ManageForm;
